/**
 * StatCard — small stat display for the 3 BI panels.
 *
 * Phase 16 / Task 16.6 (DEC-163). LABEL (uppercase 10px tracking-wide) +
 * VALUE (2xl bold).
 */
import React from 'react';

interface StatCardProps {
  readonly label: string;
  readonly value: string;
}

export function StatCard({ label, value }: StatCardProps): React.JSX.Element {
  return (
    <div className="rounded-[var(--radius-card)] bg-card p-3">
      <div className="text-xs font-medium text-[var(--color-text-tertiary)]">{label}</div>
      <div className="mt-1 text-2xl font-semibold text-foreground">{value}</div>
    </div>
  );
}
